var $5bfc78e452bdfc65$exports = {};
$5bfc78e452bdfc65$exports = {
    "info": `Information`,
    "help": `Help`
};


export {$5bfc78e452bdfc65$exports as default};
//# sourceMappingURL=en-US.mjs.map
